import util from '@bmp-vue/core/api/util'

const controller = 'UsuarioIntegracao'
export default Object.assign({}, util.GetCrud(controller, null))
